export const dastopiaAPI =
  "https://xo55y7ogyj.execute-api.us-east-1.amazonaws.com/prod/";
